export const events = [
    {
        url: new URL('../../../assets/events/a.png', import.meta.url),
        title: '2017成都Web前端大会'
    },
    {
        url: new URL('../../../assets/events/b.png', import.meta.url),
        title: '2018新耀杯 code for city 黑客松大赛'
    },
    {
        url: new URL('../../../assets/events/c.png', import.meta.url),
        title: '2017前端大会花絮'
    },
    {
        url: new URL('../../../assets/events/d.png', import.meta.url),
        title: 'FCC成都社区日常'
    }
];
